import { DtoBase } from "../DtoBase";
import { List } from "../../DiscoveryEngine.TS/Utils/List";
import { ObjSerUtils } from "DiscoveryEngine.TS/Serialization";
import { Device, DeviceDisplayNameSetting } from "DiscoveryEngine.TS/Core";


export class GetDeviceResultDto extends DtoBase {

	public Devices: List<Device>;
	public DeviceDisplayNameSetting: DeviceDisplayNameSetting;

	constructor() {
		super();

		this.Devices = new List<Device>();
		this.DeviceDisplayNameSetting = DeviceDisplayNameSetting.Default;
	}

	public get HasDevices(): boolean {
		return (!!this.Devices && this.Devices.Count > 0);
	}

	public Write(obj: any, context: any): void {
		obj.get_device_result = {};
		obj = obj.get_device_result;

		super.Write(obj, context);

		if (this.HasDevices) {
			obj.devices = [];
			ObjSerUtils.WriteObjSerCollection(obj.devices, this.Devices, context);
		}

		obj.dev_display_name_setting = DeviceDisplayNameSetting[this.DeviceDisplayNameSetting];
	}

	public Read(obj: any, context: any): void {

		if (!obj.get_device_result)
			throw new Error();
		obj = obj.get_device_result;

		super.Read(obj, context);

		if (obj.devices !== undefined) {
			this.Devices.Clear();
			ObjSerUtils.ReadObjSerCollection(obj.devices, this.Devices,
				(value: any) => new Device(), context);
		}

		if (obj.dev_display_name_setting !== undefined) {
			this.DeviceDisplayNameSetting = DeviceDisplayNameSetting[<string>obj.dev_display_name_setting];
		}
	}

}